import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { registerLocale } from 'react-datepicker'
import it from 'date-fns/locale/it'
import en from 'date-fns/locale/en-US'

// FORM
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'

// COMPONENTS
import { StarTooltip } from '../../shared/tooltips/Tooltip'

/**
 * Componente per gestire la provincia
 * EE -> se il paese è straniero
 * se è italiano la provincia deve essere di massimo 2 caratteri
 *
 * Il componente continene una label flottante
 *
 * @prop {string} name - Il nome del campo di input
 * @prop {string} label - L'etichetta per il campo
 * @prop {string} placeholder - Il placeholder per il campo
 * @prop {string} province - Il valore del campo di input
 * @prop {boolean} disabled - Se il campo deve essere disabilitato
 * @prop {Function} onFocus - Funzione di callback per l'evento onFocus del campo di input
 * @prop {Function} onChange - Funzione di callback per l'evento onChange del campo di input
 * @prop {number} maxLength - La lunghezza massima consentita per il campo (default: 2)
 * @prop {Object} error - L'oggetto di errore da mostrare per il campo
 */
export function ProvinceField(props) {
  const [error, setError] = useState()
  const lang = useSelector((state) => state.language.language)

  registerLocale(lang, lang === 'it' ? it : en)

  useEffect(() => {
    if (props.error !== undefined && props.error !== error) {
      setError(props.error)
    } else {
      setError(undefined)
    }
  }, [props.error])

  const inputWrapperClass = `input-wrapper ${props.touched && error !== undefined ? 'has-error' : ''}`

  return (
    <StarTooltip text={props.placeholder}>
      <div className={inputWrapperClass}>
        <FloatingLabel title={props.label} id="floatingLabel" label={props.label}>
          <Form.Control
            type={'text'}
            name={props.name}
            maxLength={props.maxLength || '2'}
            value={props.province || ''}
            disabled={props.disabled}
            placeholder={props.placeholder}
            isInvalid={props.touched ? error : undefined}
            onFocus={props.onFocus}
            onChange={props.onChange}
          />
        </FloatingLabel>
      </div>
    </StarTooltip>
  )
}
